import { createContext, useContext } from 'react';
import type { Map as MapboxMap } from 'mapbox-gl';

/**
 * Map context for the dashboard's mapbox-gl scene. Mirrors the
 * pattern used in the eviinfra builder so any widget child that
 * needs to read from the map (markers, camera controller, etc.)
 * pulls it from one source.
 *
 * `isLoaded` flips true on the map's `'load'` event — children
 * that mutate the map (layers, sources, markers that animate
 * camera) MUST gate their effects on it. Adding a layer before
 * the style finishes loading throws.
 */
export interface MapContextValue {
  map: MapboxMap | null;
  isLoaded: boolean;
}

export const MapContext = createContext<MapContextValue>({
  map: null,
  isLoaded: false,
});

export function useMap(): MapContextValue {
  return useContext(MapContext);
}
